import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '../Skeleton';
export default function SelectSkeleton() {
    return _jsx(Skeleton, { maxWidth: "150px", width: "100%", height: "18.19px" });
}
//# sourceMappingURL=SelectSkeleton.js.map